<template lang="pug">
  #share
    twitter
    facebook
</template>
<script>
  import Twitter from './twitter.vue';
  import Facebook from './facebook.vue';

  export default{
    components: {
      twitter: Twitter,
      facebook: Facebook,
    }
  }
</script>